


























































































































































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import {
  FocusedTask,
  localiseTaskType,
  ScheduledTask,
  isScheduledTask,
  generateTemporaryTaskId,
} from "@/data/models/Task";

import { PlanningParameters } from "@/data/models/PlanningParameters";

import { MovingTaskData } from "@/data/models/MovingTaskData";

import {
  formatDateToHoursAndMinuteString,
  formatDateToYearMonthDateString,
} from "@/utils/DateHelper";

import { firestore } from "firebase/app";
import { ButtonState } from "../common/StateButton.vue";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { getTaskTypeColor } from "@/data/models/SchedulingSettings";
import { formatProjectNameAndNumber } from "@/data/models/ProjectDetails";

import DragAppointmentComponent from "@/components/scheduling/DragAppointment.vue";
import DateAndTimePickerComponent from "@/components/common/DateAndTimePicker.vue";
import UserPickerComponent from "@/components/common/UserPickerComponent.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import DatePickerCompoment from "../common/DatePicker.vue";
import TimePickerComponent from "../common/TimePicker.vue";
import ScheduledTaskFormComponent from "./ScheduledTaskForm.vue";
import AppointmentSuggestionItemComponent from "./AppointmentSuggestionItem.vue";

import * as _ from "lodash";
import { createTimelineSettingsIncludingDate } from "@/data/models/TimelineSettings";
import router from "@/router/router";
import TaskNoteComponent from "./TaskNote.vue";
import PlanningParametersComponent from "./PlanningParameters.vue";
import { SchedulingResult } from "@/data/models/SchedulingResult";
import { AppointmentSuggester } from "@/utils/scheduling/AppointmentSuggester";
import { UserModule } from "@/store/modules/UserModule";
import { COLOR_SCHEDULING_CHECKBOX, COLOR_WHITE_BACKGROUND, COLOR_WHITE_BACKGROUND_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

enum State {
  EDIT_UNCONFIRMED,
  VIEW_CONFIRMED,
  EDIT_CONFIRMED,
  SAVE_CONFIRMED_CHANGES,
}

@Component({
  components: {
    "date-and-time-picker": DateAndTimePickerComponent,
    "date-picker": DatePickerCompoment,
    "time-picker": TimePickerComponent,
    "user-picker": UserPickerComponent,
    "drag-appointment": DragAppointmentComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "schedueled-task-form": ScheduledTaskFormComponent,
    "appointment-suggestion-item": AppointmentSuggestionItemComponent,
    "task-note": TaskNoteComponent,
    "planning-parameters-component": PlanningParametersComponent,
  },
})
export default class TaskDetailsComponent extends Vue {
  state: State = State.EDIT_UNCONFIRMED;
  checkBoxColor = COLOR_SCHEDULING_CHECKBOX;

  suggestedAppointments: SchedulingResult[] = [];
  selectedSuggestedAppointmentId: string | null = null;

  didCalculateSuggestedAppointments = false;

  appointmentSuggester = new AppointmentSuggester();

  @Prop()
  movingTaskData!: MovingTaskData | null;

  @Prop()
  focusedTask!: FocusedTask;

  @Ref("confirmationDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Ref("planningParameters")
  planningParameters!: PlanningParametersComponent;

  @Watch("state", { immediate: true })
  onCalculatedStateChanged(newState: State) {
    const isEditEnabled = newState !== State.VIEW_CONFIRMED;
    SchedulingModule.setEditEnabledForFocusedTask(isEditEnabled);
  }

  @Watch("focusedTask", { immediate: true })
  onFocusedTaskChanged(
    newFocusedTask: FocusedTask,
    oldFocusedTask?: FocusedTask
  ) {
    if (newFocusedTask.id !== oldFocusedTask?.id) {
      this.didCalculateSuggestedAppointments = false;

      if (newFocusedTask.wasConfirmed) {
        this.state = State.VIEW_CONFIRMED;
      } else {
        this.state = State.EDIT_UNCONFIRMED;
      }

      if (isScheduledTask(newFocusedTask)) {
        this.suggestedAppointments = [
          {
            scheduledTask: newFocusedTask,
            schedulingScore: null,
          },
        ];
        this.selectedSuggestedAppointmentId = newFocusedTask.id;
      } else {
        this.suggestedAppointments = [];
        this.calculateNewSuggestedDate();
      }
    } else {
      const havePlanningParametersChanged =
        !_.isEqual(
          newFocusedTask.planningParameters,
          oldFocusedTask.planningParameters
        ) || newFocusedTask.durationInMin != oldFocusedTask.durationInMin;

      if (havePlanningParametersChanged) {
        this.calculateNewSuggestedAppointments();
      } else if (!newFocusedTask.startDate) {
        this.selectedSuggestedAppointmentId = null;
        SchedulingModule.updateOccupiedTimeDataForScheduledTasks();
      }
    }
  }

  get scheduledTask(): ScheduledTask | null {
    const focusesdTask = this.focusedTask;

    if (isScheduledTask(focusesdTask)) {
      return focusesdTask;
    } else {
      return null;
    }
  }

  get calcualtedState(): State {
    if (this.state == State.EDIT_CONFIRMED) {
      if (this.hasEditedTask) {
        return State.SAVE_CONFIRMED_CHANGES;
      } else {
        return State.EDIT_CONFIRMED;
      }
    }

    return this.state;
  }

  get positiveActionButtonText() {
    switch (this.calcualtedState) {
      case State.EDIT_UNCONFIRMED:
        return this.$t("common.save").toString();
      case State.VIEW_CONFIRMED:
        return this.$t("common.change").toString();
      case State.EDIT_CONFIRMED:
        return this.$t("common.close").toString();
      case State.SAVE_CONFIRMED_CHANGES:
        return this.$t("common.save").toString();
    }

    return "";
  }

  get showNowFittingSuggestionsFoundHint() {
    return (
      this.didCalculateSuggestedAppointments &&
      this.suggestedAppointments.length == 0
    );
  }

  get negativeActionButtonText() {
    if (this.calcualtedState == State.EDIT_CONFIRMED) {
      return this.$t("common.delete").toString();
    }

    return this.$t(`common.${this.hasEditedTask ? "abort" : "close"}`);
  }

  onPositiveButtonClicked() {
    switch (this.calcualtedState) {
      case State.EDIT_UNCONFIRMED: {
        this.onSave();
        break;
      }
      case State.VIEW_CONFIRMED: {
        this.state = State.EDIT_CONFIRMED;
        break;
      }
      case State.EDIT_CONFIRMED: {
        this.onClose();
        break;
      }
      case State.SAVE_CONFIRMED_CHANGES: {
        this.onSave();
        break;
      }
    }
  }

  async onNegativeButtonClicked() {
    if (this.calcualtedState == State.EDIT_CONFIRMED) {
      this.onDelete();
      return;
    }

    if (this.hasEditedTask) {
      const discardChanges = await this.confirmationDialog.show({
        title: this.$t(
          "scheduling.taskDetails.unsavedChagnes.title"
        ).toString(),
        message: this.$t(
          "scheduling.taskDetails.unsavedChagnes.message"
        ).toString(),
        rejectMessage: this.$t("common.back").toString(),
      });

      if (!discardChanges) {
        return;
      }
    }

    this.onClose();
  }

  get suggestDateTitle() {
    return this.$tc("scheduling.taskDetails.dateSuggestions", 1).toString();
  }

  calculateNewSuggestedAppointments() {
    this.suggestedAppointments = [];
    this.clearSelectedAppointmentSuggestion();
    this.calcualteAndSelectSuggestedDate();
  }

  get cardStyle() {
    return {
      border: `2px solid red`,
      background: themed(COLOR_WHITE_BACKGROUND, COLOR_WHITE_BACKGROUND_DARK),
    };
  }

  get usersForSelection() {
    return SchedulingModule.usersQualifiedForFocusedTask;
  }

  get taskDurationInMinutes() {
    return this.focusedTask.durationInMin;
  }

  set taskDurationInMinutes(newDurationInMin: number) {
    if (newDurationInMin !== this.focusedTask.durationInMin) {
      let endDate: null | Date = null;

      const startDate = this.focusedTask.startDate;

      if (startDate) {
        const newEndDate = new Date(
          startDate.getTime() + newDurationInMin * 60000
        );
        endDate = newEndDate;

        this.suggestedAppointments = this.suggestedAppointments.map(
          (suggestedAppointment) => {
            return {
              ...suggestedAppointment,
              endDate: newEndDate,
            };
          }
        );
      }

      SchedulingModule.updateFocusedTask({
        id: this.focusedTask.id,
        updateScheduledTask: true,
        durationInMin: newDurationInMin,
        schedule:
          startDate && endDate
            ? {
                startDate,
                endDate,
              }
            : undefined,
      });
    }
  }

  get canSetTargetDateFixed() {
    return this.focusedTask.planningParameters.targetDate && this.editEnabled;
  }

  get canSetTargetTimeFixed() {
    return this.focusedTask.planningParameters.targetTime && this.editEnabled;
  }

  get canSetTargetUserFixed() {
    return this.focusedTask.planningParameters.targetUserId && this.editEnabled;
  }

  get minDate() {
    const earliestStartDate = this.focusedTask.earliestStartDate;
    const now = new Date();

    return now.getTime() > earliestStartDate.getTime()
      ? firestore.Timestamp.fromDate(now)
      : this.earliestTaskStartDate;
  }

  get earliestTaskStartDate() {
    return firestore.Timestamp.fromDate(this.focusedTask.earliestStartDate);
  }

  set earliestTaskStartDate(timestamp: firestore.Timestamp) {
    SchedulingModule.updateFocusedTask({
      id: this.focusedTask.id,
      earliestStartDate: timestamp.toDate(),
    });
  }

  get isTaskUrgent() {
    return this.focusedTask.urgent;
  }

  set isTaskUrgent(urgent: boolean) {
    SchedulingModule.updateFocusedTask({
      id: this.focusedTask.id,
      updateScheduledTask: true,
      isTaskUrgent: urgent,
    });
  }

  onSetNote(text: string | null) {
    SchedulingModule.updateFocusedTask({
      id: this.focusedTask.id,
      updateScheduledTask: true,
      note: text,
    });
  }

  async confirmConfirmationUndo() {
    return await this.confirmationDialog.show({
      title: this.$t(
        "scheduling.taskDetails.undoConfirmation.title"
      ).toString(),
      message: this.$t(
        "scheduling.taskDetails.undoConfirmation.message"
      ).toString(),
    });
  }

  async updateTaskConfirmation(value: boolean) {
    const calcualtedState = this.calcualtedState;
    const focusedTask = this.focusedTask;
    if (
      (calcualtedState == State.SAVE_CONFIRMED_CHANGES ||
        calcualtedState == State.EDIT_CONFIRMED) &&
      !value
    ) {
      const result = await this.confirmConfirmationUndo();

      if (!result) {
        return;
      }
    }

    if (!value && focusedTask.wasConfirmed) {
      SchedulingModule.undoConfirmationOfScheduledTask(focusedTask.id);
      return;
    }

    const planningParameters: PlanningParameters = {
      ...focusedTask.planningParameters,
    };

    if (value) {
      const { startDate, userId } = focusedTask;

      if (startDate) {
        planningParameters.isTargetDateFixed = true;
        planningParameters.targetDate = this.formatDateToTargetDate(startDate);

        planningParameters.isTargetTimeFixed = true;
        planningParameters.targetTime = this.formatDateToTargetTime(startDate);
      }

      if (userId) {
        planningParameters.targetUserId = userId;
      }
    }

    SchedulingModule.updateFocusedTask({
      id: focusedTask.id,
      updateScheduledTask: true,
      wasConfirmed: value,
      planningParameters: planningParameters,
    });
  }

  get taskTypeDescription() {
    return localiseTaskType(this, this.focusedTask.taskType);
  }

  get taskSpanStyle() {
    return {
      background: getTaskTypeColor(
        this.focusedTask.taskType,
        SchedulingModule.schedulingSettings.planningBoardSettings
      ),
    };
  }

  get hasProjectOwner() {
    return !!this.focusedTask.projectOwnerId;
  }

  get hasProjectSupervisor() {
    return !!this.focusedTask.projectSupervisorId;
  }

  get projectOwner() {
    return this.getUserName(this.focusedTask.projectOwnerId) ?? UserModule.userNicknameByStaffNumber(this.focusedTask.projectOwnerStaffNumber ?? "");
  }

  get projectSupervisor() {
    return this.getUserName(this.focusedTask.projectSupervisorId);
  }

  get wasTaskConfirmed() {
    return this.focusedTask.wasConfirmed;
  }

  /** Not while "Sicht auf" is active: nothing may be changed then (ticket 2610051). */
  get editEnabled() {
    return this.calcualtedState != State.VIEW_CONFIRMED && !isViewAsSelected();
  }

  get hasEditedTask() {
    return SchedulingModule.hasFocusedTaskDataChanged;
  }

  get closeBottonText() {
    return this.$t(`common.${this.hasEditedTask ? "abort" : "close"}`);
  }

  getUserName(userId: string | null) {
    if (!userId) {
      return "-";
    }

    return SchedulingModule.userLookup.getUser(userId)?.nickname ?? "-";
  }

  get positiveButtonState() {
    const calcualtedState = this.calcualtedState;
    if (calcualtedState == State.EDIT_UNCONFIRMED) {
      return this.hasEditedTask
        ? this.focusedTask?.wasConfirmed
          ? ButtonState.GREEN
          : ButtonState.YELLOW
        : ButtonState.DISABLED;
    }

    if (this.calcualtedState == State.VIEW_CONFIRMED) {
      return ButtonState.RED;
    }

    if (this.calcualtedState == State.SAVE_CONFIRMED_CHANGES) {
      return this.focusedTask?.wasConfirmed
        ? ButtonState.GREEN
        : ButtonState.YELLOW;
    }

    return ButtonState.RED;
  }

  get projectNameAndNumber() {
    const { projectName, projectNumber } = this.focusedTask;

    return formatProjectNameAndNumber(projectName, projectNumber, " ");
  }

  checkNewTaskDate(newTaskStartDate: Date) {
    const startDate = newTaskStartDate;
    const newTimestamp = startDate.getTime();

    if (newTimestamp === this.focusedTask.startDate?.getTime()) {
      return;
    }

    const endDate = new Date(
      startDate.getTime() + this.focusedTask.durationInMin * 60000
    );

    SchedulingModule.updateFocusedTask({
      id: this.focusedTask.id,
      updateScheduledTask: true,
      schedule: {
        startDate,
        endDate,
      },
    });
  }

  onTaskTimestampChanged(newValue: Date) {
    if (newValue) {
      this.checkNewTaskDate(newValue);
    }
  }

  onSave() {
    SchedulingModule.saveFocusedTaskChanges();
    SchedulingModule.triggerListUpdates();
  }

  onClose() {
    SchedulingModule.restoreInitialDataOfFocusedTask();
    SchedulingModule.clearFocusedTask();
  }

  calcualteAndSelectSuggestedDate() {
    const suggested = this.calculateNewSuggestedDate();

    if (suggested) {
      this.onAppointmentSuggestionSelected(suggested);
    }
  }

  addSuggestAppointment(scheduledTask: ScheduledTask) {
    this.suggestedAppointments = [
      ...this.suggestedAppointments,
      {
        scheduledTask,
        schedulingScore: scheduledTask.schedulingScore ?? null,
      },
    ];

    this.onAppointmentSuggestionSelected(scheduledTask);
  }

  getSuggestAppointmentOrFocusedTask(
    schedulingResult: SchedulingResult
  ): SchedulingResult {
    const focusedTask = this.focusedTask;

    if (this.isSuggestedAppointmentSelected(schedulingResult)) {
      if (isScheduledTask(focusedTask)) {
        return {
          scheduledTask: focusedTask,
          schedulingScore:
            focusedTask.schedulingScore ?? schedulingResult.schedulingScore,
        };
      } else {
        return schedulingResult;
      }
    } else {
      return schedulingResult;
    }
  }

  isSuggestedAppointmentSelected(schedulingResult: SchedulingResult): boolean {
    return (
      this.selectedSuggestedAppointmentId == schedulingResult.scheduledTask.id
    );
  }

  getMovingTaskDataForAppointment(schedulingResult: SchedulingResult) {
    if (!this.isSuggestedAppointmentSelected(schedulingResult)) {
      return null;
    }

    return this.movingTaskData;
  }

  async onDelete() {
    const didConfirmDeletion = await this.confirmationDialog.show({
      title: this.$t("scheduling.taskDetails.delete.title").toString(),
      message: this.$t("scheduling.taskDetails.delete.message").toString(),
    });

    if (didConfirmDeletion) {
      SchedulingModule.clearSchedulingInfo({
        taskId: this.focusedTask.id,
        clearFixedPlanningPlanningParameters: true,
      });

      SchedulingModule.clearFocusedTask();
    }
  }

  updateSchedulingInfoOfSelectedTask(scheduledTask: ScheduledTask) {
    this.suggestedAppointments = this.suggestedAppointments.map(
      (currentState) =>
        this.isSuggestedAppointmentSelected(currentState)
          ? {
              scheduledTask: {
                ...currentState.scheduledTask,
                startDate: scheduledTask.startDate,
                endDate: scheduledTask.endDate,
                userId: scheduledTask.userId,
              },
              schedulingScore: scheduledTask.schedulingScore ?? null,
            }
          : currentState
    );
  }

  private calculateNewSuggestedDate(): ScheduledTask | undefined {
    const result = this.appointmentSuggester.suggestAppointment(
      this.focusedTask,
      this.suggestedAppointments.map(
        (schedulingResult) => schedulingResult.scheduledTask
      )
    );

    this.didCalculateSuggestedAppointments = true;

    if (result) {
      const scheduledTask: ScheduledTask = {
        ...result.scheduledTask,
        id: generateTemporaryTaskId(),
      };

      this.suggestedAppointments = [
        ...this.suggestedAppointments,
        {
          scheduledTask: scheduledTask,
          schedulingScore: scheduledTask.schedulingScore ?? null,
        },
      ];

      return scheduledTask;
    } else {
      return undefined;
    }
  }

  clearSelectedAppointmentSuggestion() {
    SchedulingModule.clearSchedulingInfo({
      taskId: this.focusedTask.id,
    });

    this.selectedSuggestedAppointmentId = null;
  }

  onAppointmentSuggestionSelected(schedueldTask: ScheduledTask) {
    this.selectedSuggestedAppointmentId = schedueldTask.id;

    const startDate = schedueldTask.startDate;
    const endDate = new Date(
      schedueldTask.startDate.getTime() + this.focusedTask.durationInMin * 60000
    );

    SchedulingModule.updateFocusedTask({
      id: this.focusedTask.id,
      updateScheduledTask: true,
      schedule: {
        startDate,
        endDate,
      },
      score: schedueldTask.schedulingScore,
      userId: schedueldTask.userId,
    });

    SchedulingModule.setTimelineSettings(
      createTimelineSettingsIncludingDate(
        schedueldTask.startDate,
        SchedulingModule.timelineSettings,
        SchedulingModule.timelineConfiguration
      )
    );
  }

  formatDateToTargetTime(date: Date): string {
    return formatDateToHoursAndMinuteString(date);
  }

  formatDateToTargetDate(date: Date): string {
    return formatDateToYearMonthDateString(date);
  }

  async onRemoveScheduledTask(taskId: string) {
    const result =
      this.state == State.EDIT_UNCONFIRMED ||
      !this.focusedTask.wasConfirmed ||
      (await this.confirmConfirmationUndo());

    if (result) {
      this.selectedSuggestedAppointmentId = null;

      SchedulingModule.clearSchedulingInfo({
        taskId: taskId,
        clearFixedPlanningPlanningParameters: true,
      });
    }
  }

  onOpenProjectDetails() {
    const { projectId } = this.focusedTask;

    router.push({
      path: `/main/projects/${projectId}`,
    });
  }
}
